(() => {
  const prefersReducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const bindAccordion = (details) => {
    const summary = details.querySelector('summary');
    const content = details.querySelector('.licohenna-salon-list__panel');
    const inner = details.querySelector('.licohenna-salon-list__panel-inner');
    if (!summary || !content || !inner) return;

    const duration = 250;
    let animating = false;
    let targetOpen = details.open;
    let onTransitionEnd = null;
    let fallbackTimer = 0;

    const clearAnimation = () => {
      if (onTransitionEnd) {
        content.removeEventListener('transitionend', onTransitionEnd);
        onTransitionEnd = null;
      }
      if (fallbackTimer) {
        window.clearTimeout(fallbackTimer);
        fallbackTimer = 0;
      }
    };

    const currentHeight = () => content.getBoundingClientRect().height;

    const targetHeight = () => inner.getBoundingClientRect().height;

    const finish = (open) => {
      clearAnimation();
      details.classList.remove('is-animating');
      details.open = open;
      content.style.height = '';
      targetOpen = open;
      animating = false;
    };

    const animateHeight = (from, to, open) => {
      clearAnimation();
      animating = true;
      targetOpen = open;
      details.classList.remove('is-animating');
      content.style.height = `${Math.max(from, 0)}px`;
      void content.offsetHeight;

      if (Math.abs(from - to) < 0.5) {
        finish(open);
        return;
      }

      onTransitionEnd = (event) => {
        if (event.target !== content || event.propertyName !== 'height') return;
        finish(open);
      };
      content.addEventListener('transitionend', onTransitionEnd);
      details.classList.add('is-animating');
      content.style.height = `${Math.max(to, 0)}px`;

      fallbackTimer = window.setTimeout(() => {
        if (!animating || targetOpen !== open) return;
        finish(open);
      }, duration + 70);
    };

    const openAccordion = () => {
      const from = details.open ? currentHeight() : 0;
      details.open = true;
      animateHeight(from, targetHeight(), true);
    };

    const closeAccordion = () => {
      animateHeight(currentHeight() || targetHeight(), 0, false);
    };

    summary.addEventListener('click', (event) => {
      if (prefersReducedMotion()) return;

      event.preventDefault();

      if (targetOpen) {
        closeAccordion();
        return;
      }

      openAccordion();
    });
  };

  const enhanceRoot = (root) => {
    if (!(root instanceof Element)) return;
    root.querySelectorAll('.licohenna-salon-list__accordion').forEach(bindAccordion);
  };

  const enhanceAll = () => {
    document.querySelectorAll('.shopify-section--licohenna-salon-list').forEach(enhanceRoot);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceAll, { once: true });
  } else {
    enhanceAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target?.closest?.('.shopify-section--licohenna-salon-list') || event.target;
    if (root?.querySelector?.('.licohenna-salon-list__accordion')) enhanceRoot(root);
    else enhanceAll();
  });
})();
